// extracted by mini-css-extract-plugin
export var controlsEnter = "flyoverStyles-module__controlsEnter___cxGSU";
export var controlsEnterActive = "flyoverStyles-module__controlsEnterActive___OfEXH";
export var controlsEnterActiveShort = "flyoverStyles-module__controlsEnterActiveShort___Wxf8n";
export var controlsExit = "flyoverStyles-module__controlsExit___SjYfk";
export var controlsExitActive = "flyoverStyles-module__controlsExitActive___w4jw6";